import React, { useState, useEffect, useContext } from 'react';
import { Dialog } from '@mui/material';
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";
import AInput from '../../../../common/formFeilds/customInput/AInput';
import AButton from '../../../../common/form-fields-mui/AButton';
import { fetchAllPostPromisedData } from '../../../../common/utils/methods/commonMethods/utilityMethod';
import { endpoint } from '../../../../common/constant';
import { formattedPrice } from '../../../collectPayment/utils';
import ALoader from '../../../../common/a-loader';
import { UserDetails } from '../../../../../../../appContext';
import { successToast } from '../../../../common/utils/methods/toasterFunctions/function';

const _ = require('lodash');

const ApplyWaiveOffDialog = ({
    applyWaiveOffDialogInfo,
    setApplyWaiveOffDialogInfo,
    fetchExamChargesData
}) => {

    const userDetails = useContext(UserDetails);

    const { isOpen, examCharge = {} } = applyWaiveOffDialogInfo;
    const { courseId, termId, buId: businessAreaId } = examCharge;
    const [loading, setLoading] = useState(false);
    const [coursePricingInfo, setCoursePricingInfo] = useState(null);

    const [form, setForm] = useState({ waveOffAmount: 0 })

    const closeDialog = () => setApplyWaiveOffDialogInfo({});


    const getCourseCalculations = (coursePricingInfo, waveOffAmount = 0) => {

        const courseBaseAmount = coursePricingInfo?.baseAmount;
        const totalTaxPercentage = coursePricingInfo?.totalTaxPercentage;

        //without concession
        let taxWithoutConcession = +((courseBaseAmount * totalTaxPercentage) / 100).toFixed(4);
        let netPayableAmount = Math.round(courseBaseAmount + taxWithoutConcession);

        //when concession is applied
        const baseAmount = courseBaseAmount - waveOffAmount;
        let tax = +((baseAmount * totalTaxPercentage) / 100).toFixed(4);
        let finalPayable = Math.round(baseAmount + tax);

        let cgst = 0;
        let sgst = 0;
        let utgst = 0;
        let igst = 0;

        const taxBreakup = coursePricingInfo?.taxBreakupResDtos ?? []

        taxBreakup.forEach(j => {
            switch (j.taxCodeTypeDispVal) {
                case 'CGST':
                    cgst += +((baseAmount * j.taxPercentage) / 100).toFixed(4);
                    break;
                case 'SGST':
                    sgst += +((baseAmount * j.taxPercentage) / 100).toFixed(4);
                    break;
                case 'UTGST':
                    utgst += +((baseAmount * j.taxPercentage) / 100).toFixed(4);
                    break;
                case 'IGST':
                    igst += +((baseAmount * j.taxPercentage) / 100).toFixed(4);
                    break;
            }
        })

        setForm({
            taxes: tax,
            basePrice: courseBaseAmount,
            netPayableAmount,
            finalPayable,
            cgst,
            sgst,
            utgst,
            igst,
            //   itemType,
            //   termId:coursePricingInfo?.academicTerm,
            waveOffAmount
        })
    }

    const getCoursePricingData = async () => {
        try {
            setLoading(true);
            const reqObj = {
                courseId,
                termId,
                businessAreaId,
                isInterStateTxn: false
            }

            const resp = await fetchAllPostPromisedData(endpoint.breakup.getFeeBreakupWithTax, reqObj);
            if (resp?.code === 200) {
                const coursePricingInfo = resp?.data?.[0];
                setCoursePricingInfo(coursePricingInfo);
                getCourseCalculations(coursePricingInfo);
            }

        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);

        }
    }

    const sendForApproval = async () => {
        try {
            setLoading(true)
            // const chargeDetails = _.pick(examCharge, [
            //     'chargeTypeId',
            //     'psid',
            //     'itemType',
            //     'rollNumber',
            //     'examTimeCode',
            //     'studentClass',
            //     'examDate',
            //     'paymentMethod',
            //     'sfTransactionId',
            //     'examPaidAmount',
            //     'businessArea',
            //     'dueDate'
            // ]);

            const { mode: testMode, term: termValue, id } = examCharge;

            const reqObj = {
                // ...chargeDetails,
                ...examCharge,
                ...form,
                testMode,
                termValue,

                //static fields
                quantity: 1,
                applicationId: null,
                paymentStatus: 'Not_applicable',
                approvalStatus: 'PENDING',
                isPdcApplied: false,

                businessAreaId,
                courseId,
                termId,

                cashierName: userDetails ? `${userDetails.firstName} ${userDetails.lastName}` : "",
                cashierRequestedOn: new Date(),
                cashierUserId: userDetails?.employeeId || "",
            }

            const resp = await fetchAllPostPromisedData(`${endpoint.otherChargesConcession.create}/${id}`, reqObj, 'put');
            if (resp?.code === 200) {
                successToast('Request completed successfully!!');
                closeDialog();
                fetchExamChargesData();
            }else{
                setLoading(false);
            }

        } catch (err) {
            console.error(err);
        }

    }

    useEffect(() => {
        isOpen && getCoursePricingData();
    }, [])

    return (
        <Dialog
            open={isOpen}
            fullWidth
            maxWidth='md'
        >
            <div className='p-3'>
                {loading && <ALoader position="fixed" />}
                <div className='d-flex justify-content-between'>
                    <h3>Apply Waive Off</h3>
                    <CrossIcon onClick={closeDialog} />
                </div>

                <table className='apply-waive-off-table w-100'>
                    <thead>
                        <tr>
                            <th>Charge Type</th>
                            <th>Net Payable</th>
                            <th>Waive Off Amount</th>
                            <th>Final Amount</th>
                            <th>Action</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            <td>Exam</td>
                            <td className='font-weight-bold'>{formattedPrice(form.netPayableAmount)}</td>
                            <td>
                                <AInput
                                    type='number'
                                    value={form.waveOffAmount}
                                    handler={val => getCourseCalculations(coursePricingInfo, val)}
                                />
                            </td>
                            <td className='font-weight-bold'>{formattedPrice(form.finalPayable)}</td>
                            <td>
                                <AButton
                                    variant='primary_filled'
                                    size='xs'
                                    disabled={form?.finalPayable < 0}
                                    onClick={sendForApproval}
                                >
                                    Send For Approval
                                </AButton>
                            </td>
                        </tr>
                    </tbody>

                </table>
            </div>

        </Dialog>
    );
}

export default ApplyWaiveOffDialog;